module.exports = __webpack_public_path__ + "img/wireless-bluetooth-2.4cca0b6d.png";